<template>
  <div>
    <div class="download-version">
      <div class="tog tog--download-version top-bar" @click="showCadPlugins=!showCadPlugins">
        <div class="top-bar--left">
          <div class="version-inf">
            <font-awesome-icon icon="caret-right" v-if="!showCadPlugins"></font-awesome-icon>
            <font-awesome-icon icon="caret-down" v-else></font-awesome-icon>
            CAD PLUGINS
          </div>
        </div>
        <div class="top-bar--right"></div>
      </div>
      <b-collapse class="table table--download" v-model="showCadPlugins">
        <b-container fluid>
          <b-row>
            <b-col class="os-version-item">
              <icon-solidedge width="150" height="150"></icon-solidedge>
              <h4>Siemens SolidEdge plugin</h4>
              <div class="install-link">
                <a :href="pluginsDir + '3dprinteros_solidedge_plugin_setup.msi'" target="_blank">Download Windows Installer</a>
              </div>
              <span class="install-details">
              Windows 7, 8, 8.1, 10
            </span>
            </b-col>
            <b-col class="os-version-item">
              <icon-solidworks width="150" height="150"></icon-solidworks>
              <h4>Dassault Systemes SolidWorks plugin</h4>
              <div class="install-link">
                <a :href="pluginsDir + '3dprinteros_solidworks_plugin_setup.msi'" target="_blank">Download Windows Installer</a>
              </div>
              <span class="install-details">
              Windows 7, 8, 8.1, 10
            </span>
            </b-col>
            <b-col class="os-version-item">
              <icon-autodesk-fusion360 width="150" height="150"></icon-autodesk-fusion360>
              <h4>Autodesk Fusion 360 plugin</h4>
              <div class="install-link">
                <a :href="pluginsDir + '3dprinteros_fusion360_plugin_setup.exe'" target="_blank">Download Windows Installer</a>
              </div>
              <span class="install-details">
              Windows 7, 8, 8.1, 10
            </span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="os-version-item">
              <icon-autodesk-invertor width="150" height="150"></icon-autodesk-invertor>
              <h4>Autodesk Inventor 2017</h4>
              <div class="install-link">
                <a :href="pluginsDir + '3dprinteros_inventor_plugin_setup.exe'" target="_blank">Download Windows Installer</a>
              </div>
              <span class="install-details">
              Windows 7, 8, 8.1, 10
            </span>
            </b-col>
            <b-col class="os-version-item">
              <icon-rhinoceros width="150" height="150"></icon-rhinoceros>
              <h4>Rhinoceros 5</h4>
              <div class="install-link">
                <a :href="pluginsDir + '3dprinteros_rhino_plugin.rhi'" target="_blank">Download Windows Installer</a>
              </div>
              <span class="install-details">
              Windows 7, 8, 8.1, 10
            </span>
            </b-col>
            <b-col class="os-version-item">
              <icon-space-claim width="150" height="150"></icon-space-claim>
              <h4>ANSYS SpaceClaim</h4>
              <div class="install-link">
                <a :href="pluginsDir + '3dprinteros_spaceclaim_plugin_setup.exe'" target="_blank">Download Windows Installer</a>
              </div>
              <span class="install-details">
              Windows 7, 8, 8.1, 10
            </span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="os-version-item">
              <icon-catia width="150" height="150"></icon-catia>
              <h4>Dassault Systèmes’ CATIA</h4>
              <div class="install-link">
                <a :href="pluginsDir + '3dprinteros_catia_v5_setup.exe'" target="_blank">Download Windows Installer</a>
              </div>
              <span class="install-details">
              Windows 7, 8, 8.1, 10
            </span>
              <div class="install-instructions">
                <a href="#" id="catia-instructions">Instructions</a>
                <b-popover target="catia-instructions" placement="bottom" :triggers="['click', 'blur']">
                  <p>For 3DPrinterOS you will need following after plugin installation:</p>
                  - open "C:\Program Files\3DPrinterOS\CatiaV5\" directory in explorer; <br>
                  - <strong>Register COM DLL.</strong> Run regdll.bat;<br>
                  - <strong>Copy Icons.</strong> You need to copy icons from icons/ directory to « \Program Files\Dassault Systemes\B14\intel_a\resources\graphic\icons\»;<br>
                  - <strong>Installing Macro Library.</strong> Run Catia.
                  Go to "Tools" -> "Macro" -> "Macros..." -> "Macro libraries ...".
                  Set "Library type" to "VBA projects". Click "Add existing library" button.
                  Navigate to "C:\Program Files\3DPrinterOS\CatiaV5\3DPrinterOS.catvba".
                  Close "Macro libraries ...";<br>
                  - <strong>Create toolbar with macros and icons</strong><br>
                  Go to "Tools" -> "Customize" -> "Commands".
                  Select categorie "Macros". Choose "AccountAction". Press "Show Properties". Press button with "...".
                  On second page should be our icons. Select icon, press close. Do it for other commands.<br>
                  Go to "Tools" -> "Customize" -> "Toolbars" -> "new" -> give it name "3DPrinterOS".
                  Select it in list and press "Add commands...".
                  Find and select all commands that you have edited
                </b-popover>
              </div>
            </b-col>
            <b-col class="os-version-item">
              <icon-cura width="150" height="150"></icon-cura>
              <h4>Plugin for Cura</h4>
              <small><strong>(for version older than 3.5.0)</strong></small>
              <div class="install-link">
                <a :href="pluginsDir + '3dprinteros_cura.umplugin'" target="_blank">Download Plugin Archive</a>
              </div>
              <span class="install-details">
              Windows, Linux, Mac
            </span>
              <div class="install-instructions">
                <a href="#" id="cura-instructions">Instructions</a>
                <b-popover target="cura-instructions" placement="bottom" :triggers="['click', 'blur']">
                  <p>To use 3DPrinterOS plugin for Cura you will need following:</p>
                  - Download plugin archive<br>
                  - Open Cura applicaton;<br>
                  - In Cura application go to Plugins -> Installed Plugins ... -> Install new plugin<br>
                  - Browse and select downloaded plugin (3dprinteros_cura.umplugin)<br>
                  - Restart Cura<br>
                </b-popover>
              </div>
            </b-col>
            <b-col class="os-version-item">
              <icon-cura3 width="150" height="150"></icon-cura3>
              <h4>Plugin for Cura</h4>
              <small><strong>(for version 3.5.0 and newer)</strong></small>
              <div class="install-link">
                <a href="https://docs.google.com/document/d/e/2PACX-1vQbmOivLP58M5i4DPbXGfloyWDbyeBybpczDhHonIZzWrgO6NdUnVxmMjarH2Mh0wiNPRSSS35-Lwrr/pub" target="_blank">Installation Guide</a>
              </div>
              <span class="install-details">
              Windows, Linux, Mac
            </span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="os-version-item">
              <icon3d-max width="150" height="150"></icon3d-max>
              <h4>3DS MAX plugin</h4>
              <div class="install-link">
                <a :href="pluginsDir + '3dprinteros_3dsmax_plugin_setup.exe'" target="_blank">Download Windows Installer</a>
              </div>
              <span class="install-details">
              Windows 7, 8, 8.1, 10
            </span>
            </b-col>
            <b-col class="os-version-item">
              <icon-autodesk width="150" height="150"></icon-autodesk>
              <h4>Autodesk plugin</h4>
              <div class="install-link">
                <a :href="pluginsDir + '3dprinteros_autocad_plugin_setup.exe'" target="_blank">Download Windows Installer</a>
              </div>
              <span class="install-details">
              Windows 7, 8, 8.1, 10
            </span>
            </b-col>
            <b-col class="os-version-item">
              <icon-blender width="150" height="150"></icon-blender>
              <h4>Blender plugin</h4>
              <div class="install-link">
                <a :href="pluginsDir + '3dprinteros_blender_plugin_setup.exe'" target="_blank">Download Windows Installer</a>
              </div>
              <span class="install-details">
              Windows 7, 8, 8.1, 10
            </span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="os-version-item">
              <icon-meshlab width="150" height="150"></icon-meshlab>
              <h4>MeshLab plugin</h4>
              <div class="install-link">
                <a :href="pluginsDir + '3dprinteros_meshlab_plugin_setup.exe'" target="_blank">Download Windows Installer</a>
              </div>
              <span class="install-details">
              Windows 7, 8, 8.1, 10
            </span>
            </b-col>
          </b-row>

          <b-row class="release-notes-row">
            <b-col>
              <b-card>
                <b-card-title>Release notes and bug fixes</b-card-title>
                <b-card-text>
                  <p class="release-notes" v-bind:class="{'release-notes-less': !this.showCadReleaseNotes}" v-html="cadReleaseNotes"></p>
                  <p v-if="!showCadReleaseNotes">...</p>
                </b-card-text>
                <b-card-text class="small text-muted">
                  <a href="javascript:void(0)" v-if="!showCadReleaseNotes" @click="showCadReleaseNotes=true">Show more</a>
                  <a href="javascript:void(0)" v-if="showCadReleaseNotes" @click="showCadReleaseNotes=false">Show less</a>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
        </b-container>
      </b-collapse>
    </div>

    <div class="download-version">
      <div class="tog tog--download-version top-bar" @click="showOtherPlugins=!showOtherPlugins">
        <div class="top-bar--left">
          <div class="version-inf">
            <font-awesome-icon icon="caret-right" v-if="!showOtherPlugins"></font-awesome-icon>
            <font-awesome-icon icon="caret-down" v-else></font-awesome-icon>
            OTHER PLUGINS
          </div>
        </div>
        <div class="top-bar--right"></div>
      </div>
      <b-collapse class="table table--download" v-model="showOtherPlugins">
        <b-container fluid>
          <b-row>
            <b-col class="os-version-item">
              <icon-octoprint width="150" height="150"></icon-octoprint>
              <h4>Plugin for Octoprint</h4>
              <div class="install-link">
                <a href="https://github.com/3dprinteros/OctoPrint-3DPrinterOS/archive/master.zip" target="_blank">Download Plugin Archive</a>
              </div>
              <div class="install-instructions">
                <a href="https://docs.google.com/document/d/1EM4z70gptYEr8-MdjtyAT6xYCFQr2zjgjYR7VRPJK-U/edit?usp=sharing" target="_blank">Instructions</a>
              </div>
              <span class="install-details">
              Windows, Linux, Mac
            </span>
            </b-col>
          </b-row>

          <b-row class="release-notes-row">
            <b-col>
              <b-card>
                <b-card-title>Release notes</b-card-title>
                <b-card-text>
                  <div class="release-notes">
                    <p>
                      Developed plugin in order to connect your 3D printer to the 3DPrinterOS cloud with Octoprint server.
                      <br>
                      Supported 2 printers: Robo3D R2 and Robo3D C2
                      <br>
                      <br>
                    </p>
                  </div>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
        </b-container>
      </b-collapse>
    </div>
  </div>
</template>

<script>
  import IconAutodesk from "../icons/IconAutodesk";
  import IconAutodeskFusion360 from "../icons/IconAutodeskFusion360";
  import IconAutodeskInvertor from "../icons/IconAutodeskInvertor";
  import IconBlender from "../icons/IconBlender";
  import IconCatia from "../icons/IconCatia";
  import IconCura from "../icons/IconCura";
  import IconCura3 from "../icons/IconCura3";
  import IconMeshlab from "../icons/IconMeshlab";
  import IconOctoprint from "../icons/IconOctoprint";
  import IconRhinoceros from "../icons/IconRhinoceros";
  import IconSolidedge from "../icons/IconSolidedge";
  import IconSolidworks from "../icons/IconSolidworks";
  import IconSpaceClaim from "../icons/IconSpaceClaim";
  import Icon3dMax from "../icons/Icon3dMax";

  export default {
    name: 'plugins-download',
    components: {
      IconOctoprint,
      IconCura,
      IconMeshlab,
      IconBlender,
      IconAutodesk,
      Icon3dMax,
      IconCura3,
      IconCatia,
      IconSpaceClaim,
      IconRhinoceros,
      IconAutodeskInvertor,
      IconAutodeskFusion360,
      IconSolidworks,
      IconSolidedge
    },
    props: ['pluginsDir', 'releaseNotes'],
    data() {
      return {
        showCadPlugins: false,
        showOtherPlugins: false,
        showCadReleaseNotes: false
      }
    },

    computed: {
      cadReleaseNotes() {
        return this.releaseNotes.replace(/(?:\r\n|\r|\n)/g, '<br>');
      }
    }
  }
</script>